import PropTypes from 'prop-types'
import React from 'react'

import { DetailsActionButton, CancelButton } from '../../'
import ConfirmHeader from './ConfirmHeader'
import './Confirm.less'

function getHeaderComponent (header, className) {
  if (header) {
    return <ConfirmHeader className={className}>
      {header}
    </ConfirmHeader>
  } else {
    return null
  }
}

export default class Confirm extends React.Component {
  render () {
    const {header, className, text, onCancel, cancelText, onConfirm, confirmText} = this.props
    return (
      <div className={`${className}-container`}>
        {getHeaderComponent(header, className)}
        <div className={`${className}-body`}>
          {text}
        </div>
        <div className={`${className}-separator`} />
        <div className={`${className}-controls`}>
          <CancelButton onClick={onCancel}>{cancelText}</CancelButton>
          <DetailsActionButton onClick={onConfirm}>{confirmText}</DetailsActionButton>
        </div>
      </div>
    )
  }
}

Confirm.propTypes = {
  className: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string
}

Confirm.defaultProps = {
  className: 'confirm',
  confirmText: 'ok',
  cancelText: 'cancel'
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Confirm/index.js